export default __webpack_public_path__ + "static/media/a004-example2.5ad1b966.jpg";